<script lang="ts">
  import { date } from '$lib/helpers/commonHelpers';
  import SweatLogo from '../../../assets/svgs/sweat-logo.svelte';
  import AppStore from '../../../assets/svgs/app-store.svelte';
  import GooglePlay from '../../../assets/svgs/google-play.svelte';
  import type { NavigationColumnsProps, SocialLinksProps } from '../../types/layoutTypes';

  export let isLayoutHidden: boolean | undefined;
  export let navigationColumns: NavigationColumnsProps | undefined;
  export let socialLinks: SocialLinksProps | undefined;

  let bottomLinks = [
    { title: 'Privacy Policy', url: '/privacy-policy' },
    { title: 'Terms of Use', url: '/terms-of-use' },
    { title: 'Cookie Policy', url: '/cookie-policy' },
    //{ title: 'Diversity and Inclusion', url: '/diversity-inclusion' },
    {
      title: 'Do Not Sell My Information',
      url: 'https://join.sweat.com/en/do-not-sell-my-information',
    },
  ];

  $: largeGrid =
    navigationColumns?.length == 4
      ? 'lg:grid-cols-4'
      : navigationColumns?.length == 3
        ? 'lg:grid-cols-3'
        : '';
</script>

<footer class="sticky top-[100vh]">
  {#if !isLayoutHidden}
    <div class="flex justify-center lg:pb-12 lg:pt-16">
      <div class="max-w-1280 w-full py-12 flex flex-col lg:flex-row lg:gap-16 lg:py-0 lg:px-8">
        <div class="px-4 lg:w-[22.25rem] lg:px-0">
          <SweatLogo />
          <p class="pt-6 font-normal text-gray-600">
            The fitness app trusted by millions of women.
          </p>
        </div>
        <div
          class="w-full px-4 pt-12 grid grid-cols-2 gap-8 lg:pt-0 lg:px-0 {largeGrid} lg:grid-rows-1 lg:grid-flow-col"
        >
          {#if navigationColumns?.length}
            {#each navigationColumns as panel}
              <div class="w-full flex flex-col gap-4">
                <p class="text-sm text-gray-500 font-semibold">{panel.title}</p>
                {#if panel?.itemsCollection?.items?.length}
                  <ul class="flex flex-col gap-3">
                    {#each panel.itemsCollection.items as link}
                      <li>
                        <a class="text-gray-600 font-semibold leading-6" href={link.url}
                          >{link.title}</a
                        >
                      </li>
                    {/each}
                  </ul>
                {/if}
              </div>
            {/each}
          {/if}
        </div>
      </div>
    </div>

    <div class="py-8 flex lg:justify-center lg:py-0 lg:pb-12">
      <div class="max-w-1280 px-4 lg:px-8 flex flex-col w-full justify-between gap-8 lg:flex-row">
        <div class="flex flex-col gap-4">
          <b class="text-sm font-semibold text-gray-900">Get the Sweat App</b>
          <div class="flex gap-4">
            <a
              href="https://apps.apple.com/us/app/sweat-fitness-app-for-women/id1049234587"
              aria-label="Apple store link"
            >
              <AppStore />
            </a>
            <a
              href="http://play.google.com/store/apps/details?id=com.kaylaitsines.sweatwithkayla&pli=1 "
              aria-label="Google play link"
            >
              <GooglePlay />
            </a>
          </div>
        </div>
        <div class="flex items-end gap-6 lg:py-2">
          {#if socialLinks}
            {#each socialLinks as socialLink}
              <a href={socialLink.url}>
                <img
                  src={socialLink.image?.url}
                  alt={socialLink.image?.description || socialLink.image?.title}
                  class="w-[{socialLink.image?.width}]"
                />
              </a>
            {/each}
          {/if}
        </div>
      </div>
    </div>
  {/if}

  <div class="py-4 flex bg-gray-100 lg:justify-center">
    <div class="max-w-1280 w-full flex flex-col px-4 lg:px-8">
      <div
        class="border-t-gray-200 border-t py-4 flex flex-col gap-4 lg:justify-between md:flex-row"
      >
        <div class="flex flex-row flex-wrap gap-4 items-center">
          {#each bottomLinks as link}
            <a class="text-xs text-gray-500" href={link.url}>{link.title}</a>
          {/each}
        </div>
        <p class="text-xs sm:w-80 text-gray-400 font-medium lg:w-auto">
          © Sweat {date.getFullYear()}, The Bikini Body Training Company Pty Ltd. All rights
          reserved.
        </p>
      </div>
    </div>
  </div>
</footer>
